import { useEffect, useState } from 'react'
import Template from './../../Template'
import * as SG from '../../../style/Styles'
import * as S from '../../../style/User'
import * as TXT from './../../../util/Texts'
import { useParams, useNavigate } from "react-router-dom"
import * as LanguageService from './../../../services/Language.service'
import { ERROR_ALERT, SUCCESS_ALERT } from './../../../util/AlertsMsg'
import * as U from './../../../util/UrlHttp'

export default function LanguageForm() {
  const { id } = useParams()
  const navigate = useNavigate()
  
  const [langName, setLangName] = useState<string>('')
  const [langIcon, setLangIcon] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(true)
  const [values, setValues] = useState<Record<string, string>>({})

  // Obter todas as chaves constantes do Texts.ts que sejam strings
  const textKeys = Object.keys(TXT).filter(key => typeof (TXT as any)[key] === 'string');

  const getDataLanguage = async () => {
    setLoading(true)
    const result = await LanguageService.GetLanguage(id)
    if (result.data && result.data.status) {
      const language = result.data.language
      setLangName(language.name_lang)
      setLangIcon(language.icon)
      
      const apiTexts = language.texts || {}
      const initialValues: Record<string, string> = {}
      
      textKeys.forEach(key => {
        // Se já existir no JSON do banco, usa. Senão, faz fallback para o texto padrão em PT
        initialValues[key] = apiTexts[key] !== undefined ? apiTexts[key] : (TXT as any)[key]
      })
      
      setValues(initialValues)
    } else {
      ERROR_ALERT(TXT.WRONG_TRY_AGAIN)
      navigate('/languages')
    }
    setLoading(false)
  }

  const handleInputChange = (key: string, val: string) => {
    setValues(prev => ({
      ...prev,
      [key]: val
    }))
  }

  const handleSend = async () => {
    const result = await LanguageService.UpdateLanguageTexts(id, values)
    if (result.data && result.data.status) {
      SUCCESS_ALERT(result.data.message)
      setTimeout(() => {
        navigate('/languages')
      }, 1500)
    } else {
      try {
        ERROR_ALERT(result.response.data.message)
      } catch (error) {
        console.warn(error)
        ERROR_ALERT(TXT.WRONG_TRY_AGAIN)
      }
    }
  }

  useEffect(() => {
    if (id !== undefined) {
      getDataLanguage()
    } else {
      navigate('/languages')
    }
  }, [])

  return (
    <Template>
      <SG.PADD style={{ paddingBottom: '40px' }}>
        <S.BoxFormInteral className='formLanguage' style={{ maxWidth: '1100px', width: '100%', margin: '0 auto' }}>
          
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 15, marginBottom: 30 }}>
            {langIcon && (
              <img 
                src={`${langIcon}`} 
                alt={langName}
                onError={(e) => {
                  e.currentTarget.src = `${U.BASE_BACK}${U.ICON_BR}`;
                }}
                style={{ width: 48, height: 32, objectFit: 'cover', borderRadius: 4, border: '1px solid #ccc', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}
              />
            )}
            <SG.Title style={{ textAlign: 'center', margin: 0 }}>
              {langName ? `Traduções - ${langName}` : 'Editar Traduções'}
            </SG.Title>
          </div>

          {loading ? (
            <div style={{ textAlign: 'center', padding: '40px 0' }}>
              <SG.IMG src='/img/loading.gif' alt='Carregando' style={{ width: 50 }} />
              <p>{TXT.LOADING_LANGUAGES}</p>
            </div>
          ) : (
            <>
              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(auto-fit, minmax(450px, 1fr))', 
                gap: '24px 30px', 
                marginBottom: 30,
                maxHeight: '60vh',
                overflowY: 'auto',
                padding: '10px 15px',
                border: '1px solid #e0e0e0',
                borderRadius: 12,
                backgroundColor: '#fafafa'
              }}>
                {textKeys.map((key) => (
                  <div key={key} style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span style={{ fontSize: 13, fontWeight: 'bold', color: '#1976d2' }}>{key}</span>
                      <span style={{ fontSize: 11, color: '#888', fontStyle: 'italic' }}>Padrão (PT)</span>
                    </div>
                    <div style={{ 
                      fontSize: 12, 
                      color: '#555', 
                      backgroundColor: '#f0f2f5', 
                      padding: '6px 10px', 
                      borderRadius: 6,
                      borderLeft: '3px solid #1976d2',
                      wordBreak: 'break-word',
                      marginBottom: 4
                    }}>
                      {(TXT as any)[key]}
                    </div>
                    <SG.InputInternal 
                      name={key}
                      value={values[key] || ''}
                      placeholder={`Tradução para ${key}`}
                      onChange={(e) => handleInputChange(key, e.target.value)}
                      style={{ marginTop: 0 }}
                    />
                  </div>
                ))}
              </div>

              <SG.Div className='boxbutton' style={{ display: 'flex', justifyContent: 'center', gap: 15 }}>
                <SG.PrimaryButtom 
                  onClick={() => navigate('/languages')} 
                  style={{ backgroundColor: '#757575', color: '#fff' }}
                >
                  <i className="fa-solid fa-arrow-left"></i> {TXT.GO_BACK}
                </SG.PrimaryButtom>
                
                <SG.PrimaryButtom onClick={handleSend}>
                  <i className="fa-regular fa-floppy-disk"></i> {TXT.SAVE}
                </SG.PrimaryButtom>
              </SG.Div>
            </>
          )}

        </S.BoxFormInteral>
      </SG.PADD>
    </Template>
  )
}
